import { createLoaderImp } from '../../../../components/ozmoit/common';
import { getProgramFormDataAction } from '../actions';

const {
  useLoaderData: useProgramFormLoaderData,
  LoaderConsumerSimple,
  LoaderProvider,
} = createLoaderImp({
  action: getProgramFormDataAction,
});

function ProgramFormLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  return (
    <LoaderProvider {...props}>
      <LoaderConsumerSimple>{children}</LoaderConsumerSimple>
    </LoaderProvider>
  );
}

export { ProgramFormLoader, useProgramFormLoaderData };
